module.exports = __webpack_public_path__ + "static/media/Competitors.9a4c49c9.webp";